import React, { useMemo } from "react";
import { useFormContext, Controller, useWatch  } from "react-hook-form";

import FormSimple from "@components/formGroup/formSimple";
import LocationSearchInput from "@components/input/locationSearchInput";
import BlackTooltip from "@components/tooltip/BlackTooltip";
import { useTranslation } from "react-i18next";
import { useUserPermission } from "@hooks/users";
import { useNotification } from "@hooks/useNotification";

function SharedAdress(props) {
  const { readOnly = false, isEnterprisePage } = props;
  const { control, setValue, getValues } = useFormContext();
  const {t: translator} = useTranslation("pages.employés.infoPers");
  const { canAccessAddress } = useUserPermission();
  const {showInfo} = useNotification()
  //const [spareWheelAddress, setSpareWheelAddress] = useState("");
  const firstAdressWatcher = useWatch({name: "adress.firstAdress"});
  // const cityWatcher = useWatch({ name: "adress.city" });
  // const provinceWatcher = useWatch({ name: "adress.province" });
  // const countryWatcher = useWatch({ name: "adress.country" });

  const readOnlyAddress = useMemo(() => {
    return isEnterprisePage ? readOnly : (readOnly && !canAccessAddress);
  }, [readOnly, isEnterprisePage, canAccessAddress])

  function handleSelectLocation(firstAdress, additionalInfo) {
    if(props.setSuperZIndex) props.setSuperZIndex("") 
    if (additionalInfo) {
      if(!additionalInfo.latLng) return showInfo("information_adress_incomplete")
      setValue("adress.firstAdress", firstAdress, { shouldDirty: true });
      setValue("adress.zipCode", additionalInfo.postalCode, { shouldDirty: true });
      setValue("adress.province", additionalInfo.province, { shouldDirty: true });
      setValue("adress.city", additionalInfo.city, { shouldDirty: true });
      setValue("adress.country", additionalInfo.country, { shouldDirty: true });
      setValue("adress.countryCode", additionalInfo.countryCode, { shouldDirty: true });
    }
  }

  // useEffect(() => {
  //   if (cityWatcher || provinceWatcher || countryWatcher) {
  //     const addressReplacments = [];
  //     if (cityWatcher) addressReplacments.push(cityWatcher);
  //     if (provinceWatcher) addressReplacments.push(provinceWatcher);
  //     if (countryWatcher) addressReplacments.push(countryWatcher);
  //     setSpareWheelAddress(addressReplacments.join(', '))
  //   }
  // }, [cityWatcher, provinceWatcher, countryWatcher])

  function handleChangeLocation() {
    const adress = getValues("adress");
    // if(props.setSuperZIndex) props.setSuperZIndex("arh-z-[4]");
    if (adress) {
      setValue("adress.firstAdress", "");
      setValue("adress.zipCode", "");
      setValue("adress.province", "");
      setValue("adress.city", "");
      setValue("adress.country", "");
      setValue("adress.countryCode", "");
    }
  }

  return (
    <div className="arh-pr-[1rem] arh-pl-[5.8rem] arh-pb-[2rem] arh-w-full arh-flex arh-items-center tablet-850:arh-flex-wrap tablet-850:arh-items-start tablet-850:arh-justify-start tablet-850:arh-gap-x-5 tablet-850:arh-gap-y-0 tablet-850:!arh-pl-[2.5rem] tablet-850:!arh-pr-[1rem]">
      <div className="arh-flex-[0.25_0.25_0] arh-mr-[1.875rem] arh-mb-[1.75rem] tablet-850:!arh-mr-0 tablet-850:arh-min-w-0 tablet-850:!arh-w-[calc(50%_-_0.625rem)] tablet-850:!arh-flex-[0_0_calc(50%_-_0.625rem)]">
        <BlackTooltip title={readOnlyAddress ? firstAdressWatcher : ""} placement="top">
          <span className="arh-inline-block arh-w-full">
            <LocationSearchInput
              className="arh-w-full !arh-mr-[3rem] tablet-850:!arh-mr-0"
              label={translator("Adresse")}
              labelContent={true}
              classInput="focus_green"
              isValid={true}
              onSelect={handleSelectLocation}
              onChange={handleChangeLocation}
              defaultValue={firstAdressWatcher}
              isDisabled={readOnlyAddress}
            />
          </span>
        </BlackTooltip>
      </div>
      <div className="arh-flex-[0.25_0.25_0] arh-mr-[1.875rem] tablet-850:!arh-mr-0 tablet-850:arh-min-w-0 tablet-850:!arh-w-[calc(50%_-_0.625rem)] tablet-850:!arh-flex-[0_0_calc(50%_-_0.625rem)]">
        <Controller
          control={control}
          name="adress.secondAdress"
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <BlackTooltip title={readOnlyAddress ? value : ""} placement="top">
              <span className="arh-inline-block arh-w-full">
                <FormSimple
                  label={translator("Adresse complémentaire")}
                  placeholder={translator("Adresse (suite)")}
                  ParentForm="arh-mb-[1.75rem]"
                  classLabel="arh-flex"
                  type="text"
                  onChange={onChange}
                  value={value}
                  readOnly={readOnlyAddress}
                />
              </span>
            </BlackTooltip>
          )}
        />
      </div>
    </div>
  );
}

export default SharedAdress;
